import request from '@/utils/request'

// 查询车辆GIS分布
export function findEbikeNewGisProfileList(data) {
  return request({
    url: '/ebike/listek-ebike/web/ebike/findEbikeGisProfileList',
    method: 'post',
    data
  })
}
